import React from 'react';
import { isEmpty } from 'lodash';
import Head from 'next/head';

interface IProps {
	seoSetting: {
		seoTitle: string;
		seoDescription: string;
		seoKeywords: string;
		seoImage?: string;
	}
}

const CustomSeo = ({ seoSetting }: IProps): JSX.Element => {
	const {
		seoTitle, seoDescription, seoKeywords, seoImage,
	} = seoSetting;

	return (
		<>
			{/* Override SEO setting in BasicSeo component */}
			{!isEmpty(seoSetting) && (
				<Head>
					{seoTitle && (
						<>
							<title>{seoTitle}</title>
							<meta property="og:title" content={seoTitle} key="og-title" />
						</>
					)}
					{seoDescription && (
						<>
							<meta name="description" content={seoDescription} key="description" />
							<meta
								property="og:description"
								content={seoDescription}
								key="og-description"
							/>
						</>
					)}
					{seoKeywords && <meta name="keywords" content={seoKeywords} />}
					{seoImage && <meta property="og:image" content={seoImage} key="og-image" />}
				</Head>
			)}
		</>
	);
};

export default CustomSeo;
